import { render, staticRenderFns } from "./AppStore.vue?vue&type=template&id=6235de08&scoped=true"
import script from "./AppStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStore.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStore.vue?vue&type=style&index=0&id=6235de08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235de08",
  null
  
)

export default component.exports